interface ButtonWithTooltipProps {
  icon: JSX.Element;
  tooltip: string;
  handler: () => void;
  className?: string;
}

export const ButtonWithTooltip = ({
  icon,
  tooltip,
  handler,
  className = "btn btn-ghost btn-sm rounded-lg",
}: ButtonWithTooltipProps) => {
  const handleOnClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handler();
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.stopPropagation();
      handler();
    }
  };

  return (
    <div
      className="tooltip tooltip-top flex items-center"
      data-tip={tooltip}
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
    >
      <button type="button" className={className}>
        {icon}
      </button>
    </div>
  );
};
